import Gate from "components/Gate";
import {
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  Grid,
  TextField as MuiTextField,
} from "@mui/material";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import MuiAlert from "@mui/material/Alert";
import { spacing } from "@mui/system";
import CurrencyTextField from "../../../components/Inputs/CurrencyTextField";
// Redux Components
import PropTypes from "prop-types";
import React from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
// Custom UI componets and functions:
import { txtBoxDateFormatter } from "../../../setup/helpers";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { put as UpdateAccountDisconnect } from "../api/actions";

const CenteredContent = styled.div`
  text-align: center;
`;

const CircularProgress = styled(MuiCircularProgress)(spacing);
const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const FormControl = styled(MuiFormControl)(spacing);
const TextField = styled(MuiTextField)(spacing);
const SpacedCurrencyTextField = styled(CurrencyTextField)(spacing);

// Custom Styles for property selection drop down

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  typography: {
    flexGrow: 1,
    textAlign: "center",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ExistingAccountDisconnectForm = (props) => {
  // Assigns the forms current disconnect Index from a props variable passed on the main ui. This allows the form to work from the stores saved object

  // When editing is saved that disconnect is replaced in the store with the new form of the object. Upon sucessfull db updating

  const classes = useStyles();
  const dispatch = useDispatch();

  const save = () => {
    dispatch(setSnackbar(false, "warning", "Updating Account Disconnect"));
    let updateObject = {
      uuid: props.accountDisconnects.data.accountDisconnectsList.items[
        props.disconnectIndex
      ].uuid,
      id: props.accountDisconnects.data.accountDisconnectsList.items[
        props.disconnectIndex
      ].id,

      reconnectDate:
        props.accountDisconnects.data.accountDisconnectsList.items[
          props.disconnectIndex
        ].reconnectDate,
      disconnectDate:
        props.accountDisconnects.data.accountDisconnectsList.items[
          props.disconnectIndex
        ].disconnectDate,
      disconnectAmt:
        props.accountDisconnects.data.accountDisconnectsList.items[
          props.disconnectIndex
        ].disconnectAmt,
      notes:
        props.accountDisconnects.data.accountDisconnectsList.items[
          props.disconnectIndex
        ].notes,
    };
    props.UpdateAccountDisconnect(updateObject, false).then(() => {
      dispatch(setSnackbar(false, "success", "Disconnect updated"));
    });
  };

  // Updates the local state object of "bill in progress" upon each modification
  const onFieldChange = (event) => {
    // Gets the current vendor info data and updates it with the event's name and value:
    if (event.target.type == "number") {
      props.accountDisconnects.data.accountDisconnectsList.items[
        props.disconnectIndex
      ][event.target.name] = Number(event.target.value);
    } else if (event.target.id && event.target.id.includes("totalField_")) {
      var value = event.target.value;
      value = value.replace(/\,/g, ""); // 1125, but a string, so convert it to number
      value = parseInt(value, 10);
      props.accountDisconnects.data.accountDisconnectsList.items[
        props.disconnectIndex
      ][event.target.name] = value;
    } else {
      props.accountDisconnects.data.accountDisconnectsList.items[
        props.disconnectIndex
      ][event.target.name] = event.target.value;
    }
  };
  return (
    <Card mb={6} elevation={3}>
      {!props.accountDisconnects.isLoading &&
        props.accountDisconnects.data.accountDisconnectsList.items.length > 0 &&
        props.disconnectIndex != null && (
          <CardContent>
            <Grid container spacing={4}>
              {/* Main Grid */}
              <Grid item lg={4} md={12} sm={12}>
                <TextField
                  id="reconnectDate"
                  label="Reconnect Date"
                  type="date"
                  fullWidth
                  my={2}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  defaultValue={txtBoxDateFormatter(
                    props.accountDisconnects.data.accountDisconnectsList.items[
                      props.disconnectIndex
                    ].reconnectDate
                  )}
                  onChange={onFieldChange}
                  name="reconnectDate"
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <TextField
                  id="disconnectDate"
                  label="Disconnect Date"
                  type="date"
                  fullWidth
                  my={2}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  defaultValue={txtBoxDateFormatter(
                    props.accountDisconnects.data.accountDisconnectsList.items[
                      props.disconnectIndex
                    ].disconnectDate
                  )}
                  onChange={onFieldChange}
                  name="disconnectDate"
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <TextField
                  id="totalField_disconnectAmt"
                  label="Disconnect Ammount(USD)"
                  onChange={onFieldChange}
                  name="disconnectAmt"
                  type="number"
                  defaultValue={
                    props.accountDisconnects.data.accountDisconnectsList.items[
                      props.disconnectIndex
                    ].disconnectAmt
                  }
                  fullWidth
                  my={2}
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12}>
                <TextField
                  label="Disconnect Note"
                  id="notes"
                  multiline={true}
                  rows={10}
                  rowsMax={10}
                  variant="outlined"
                  my={2}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  defaultValue={
                    props.accountDisconnects.data.accountDisconnectsList.items[
                      props.disconnectIndex
                    ].notes
                  }
                  onChange={onFieldChange}
                  name="notes"
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} justify={"flex-end"}>
              <Grid item>
                <Gate capability="disconnects">
                <MuiButton variant="contained" onClick={save} color="secondary">
                  Save
                </MuiButton>
                </Gate>
              </Grid>
              <Grid item>
                <MuiButton
                  variant="contained"
                  onClick={props.onCancel}
                  color="primary"
                >
                  Cancel
                </MuiButton>
              </Grid>
            </Grid>
          </CardContent>
        )}
    </Card>
  );
};

// Component Properties
ExistingAccountDisconnectForm.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  accountsSearch: PropTypes.object.isRequired,

  // Store object functions:
  UpdateAccountDisconnect: PropTypes.func.isRequired,
};

// Component State
function ExistingAccountDisconnectFormState(state) {
  return {
    user: state.user,
    apl: state.apl,
    accountsSearch: state.accountsSearch,
  };
}
export default connect(ExistingAccountDisconnectFormState, {
  UpdateAccountDisconnect,
})(ExistingAccountDisconnectForm);
